import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";
import { getDateOnly, convertPersianDateToDateTime } from "../../utils/jalali";
import CustomReadOnly from "../ReadOnlyBox/CustomReadOnly";
const CustomDatePicker = (props) => {
    const { value, onChange, readOnly, label = null, placeHolder = null, placeHolderStyle, labelStyle, isMobile = false, boxStyle, labelTextStyle, inputTextStyle } = props;
    const convertedValue = value ? convertPersianDateToDateTime(value) : null;
    const theme = useTheme();
    const readMode = _jsx(CustomReadOnly, { label: label !== null && label !== void 0 ? label : "", content: value !== null && value !== void 0 ? value : "", labelStyle: labelTextStyle, contentStyle: inputTextStyle });
    const persianShortWeekDays = ["ی", "د", "س", "چ", "پ", "ج", "ش"]; // Sun..Sat
    const formatPersianWeekday = (date) => {
        var _a;
        if (!date)
            return "";
        const dayNumber = new Date(date).getDay();
        return (_a = persianShortWeekDays[dayNumber]) !== null && _a !== void 0 ? _a : "";
    };
    const editMode = (_jsxs(_Fragment, { children: [label && (_jsx(FormControlLabel, { control: _jsx(Typography, { variant: "h6" }), label: _jsx(Typography, { sx: Object.assign({}, labelStyle), children: label }), style: { margin: 0, alignItems: "start" } })), _jsx(DatePicker, { sx: {
                    width: isMobile ? "100%" : "auto",
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        fontFamily: "IRANSansX",
                        backgroundColor: theme.palette.mode === "dark"
                            ? theme.palette.background.paper
                            : "#fff",
                        color: theme.palette.text.primary,
                        height: "36px",
                        mr: "12px",
                    },
                }, label: _jsx(Typography, { sx: Object.assign(Object.assign({}, placeHolderStyle), { mb: "5px" }), children: placeHolder }), value: convertedValue, dayOfWeekFormatter: (date) => formatPersianWeekday(date), onChange: (event) => {
                    onChange(getDateOnly(event === null || event === void 0 ? void 0 : event.toISOString()));
                }, 
                //format={value ? "yyyy/MM/dd" : "yyyy/MM/dd"}
                slotProps: {
                    textField: {
                        placeholder: "روز / ماه / سال",
                    },
                }, localeText: {
                    toolbarTitle: "انتخاب تاریخ",
                    cancelButtonLabel: "انصراف",
                    okButtonLabel: "تایید",
                } })] }));
    return _jsx(_Fragment, { children: readOnly ? readMode : editMode });
};
export default CustomDatePicker;
